"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var framer_motion_1 = require("framer-motion");
var react_1 = __importDefault(require("react"));
var replaceAccentuation_1 = require("../../../Utils/replaceAccentuation");
var select_context_1 = require("../../select.context");
var S = __importStar(require("../common.styled"));
var animations_1 = require("./animations");
var NoOption_1 = __importDefault(require("./NoOption"));
var Options_1 = __importDefault(require("./Options"));
var StaticOptions = function () {
    var _a = (0, select_context_1.useSelect)(), optionsVisible = _a.optionsVisible, options = _a.options, searchFilter = _a.searchFilter;
    var contentOptionRef = react_1.default.useRef(null);
    var optionsToRender = react_1.default.useMemo(function () {
        return options.filter(function (option) {
            return (0, replaceAccentuation_1.replaceAccentuation)(option.label).includes((0, replaceAccentuation_1.replaceAccentuation)(searchFilter) || '');
        });
    }, [searchFilter, options]);
    return (react_1.default.createElement(framer_motion_1.AnimatePresence, null, optionsVisible && (react_1.default.createElement(S.ContentOption, { variants: animations_1.dropDownAnimation, initial: "initial", animate: "animateOptions", exit: "exit", ref: contentOptionRef },
        react_1.default.createElement(S.ContentScroll, null,
            react_1.default.createElement(Options_1.default, null),
            react_1.default.createElement(NoOption_1.default, { optionsToRender: optionsToRender }))))));
};
exports.default = StaticOptions;
